/*
 * Copyright (c) 2024 Helvia Technologies PC <contact@helvia.io>
 */

import { IS_LOGIN_SCREEN_REDIRECT_DISABLED } from '../../constants/env';
import { NAV_LOGIN } from '../../constants/navigation';
import { TEMP_STORAGE_KEYS } from '../../constants/main';
import { isTokenOfOrganization } from '../../utils/auth/isTokenOfOrganization';

let isRedirecting = false;

/**
 * Get the login URL. This function is used to retrieve the url which will be used to redirect the user to the login page.
 * @param {Function} getState - The getState function from the redux store. If not provided, the function will look in to the local storage for the token.
 * @return {String | null} The login URL or null if the user should not be redirected.
 */
export function getLoginUrl(getState) {
  if (window.location.pathname === NAV_LOGIN && IS_LOGIN_SCREEN_REDIRECT_DISABLED) {
    return null;
  }

  const token = getState != null ? getState().auth?.token : localStorage.getItem(TEMP_STORAGE_KEYS.TOKEN);
  const organizationId = getState != null ? getState().auth?.organizationId : localStorage.getItem(TEMP_STORAGE_KEYS.ORGANIZATION_ID);

  const navSuffix = isTokenOfOrganization(token, organizationId) ? `?orgId=${organizationId}` : '';
  return `${NAV_LOGIN}${navSuffix}`;
}

/**
 * Redirect the user to the login page if needed.
 * @param {String} loginUrl - The login URL.
 */
export function redirectToLoginIfNeeded(loginUrl) {
  if (loginUrl && !isRedirecting) {
    isRedirecting = true;
    window.location.assign(loginUrl);
  }
}
